import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { BranchForm } from "./BranchForm";
import { BorderedFormGrid } from "../../../Forms/BorderedFormGrid";
import { branchDefaultValues } from "./branchDefaultValues";
import { Branch } from "../../Branch";
import { SmallAddButton } from "../../../Layout/Buttons/SmallAddButton";
import { useFetchBranchesForCarrier } from "../../Hooks/useFetchBranchesForCarrier";
import { confirm } from "../../../Layout/Dialog/ConfirmDialog";
import { useDeleteBranch } from "../../Hooks/useDeleteBranch";
import { ReadOnlyProps } from "../../../Project/EditProject/ReadOnlyProps";

type Props = {
  carrierId: number;
};

export const BranchAccordion = ({ carrierId, isReadOnly }: Props & ReadOnlyProps) => {
  const { data: existingBranches, refetch: refetchBranches } =
    useFetchBranchesForCarrier(carrierId);
  const [branches, setBranches] = useState<Branch[]>([]);
  useEffect(() => {
    setBranches(existingBranches ?? []);
  }, [existingBranches]);

  const addBranch = (newBranch: Branch) => {
    setBranches((currentBranches) => [newBranch, ...currentBranches]);
  };

  const { mutateAsync: deleteBranch } = useDeleteBranch();

  const deleteBranchWithToast = async (branch: Branch) => {
    if (await confirm(`Do you really want to delete branch ${branch.Name}?`)) {
      deleteBranch(branch.Id).then(async () => {
        await refetchBranches();
      });
    }
  };

  return (
    <>
      <SmallAddButton
        onClick={() => addBranch(branchDefaultValues(carrierId))}
        disabled={isReadOnly}
      />

      <Grid container>
        <Grid item xs={12} container justifyContent="center">
          {branches.length === 0 ? (
            <BorderedFormGrid>
              <Grid item xs={12}>
                No branches available for this carrier.
              </Grid>
            </BorderedFormGrid>
          ) : (
            branches.map((branch) => (
              <Grid item xs={12} key={branch.Id}>
                <BranchForm
                  initialBranch={branch}
                  deleteBranch={deleteBranchWithToast}
                  isReadOnly={isReadOnly}
                />
              </Grid>
            ))
          )}
        </Grid>
      </Grid>
    </>
  );
};
